export default __webpack_public_path__ + "static/media/icon-enterprise.7167b08b.svg";